export interface AuditorExportDialogProps {
  isOpen: boolean;
  onClose: () => void;
  companyID?: string;
  onExportComplete?: (result: any) => void;
  onError?: (error: Error) => void;
  showLoading?: (show: boolean) => void;
}

// Framework options matching the original dialog
export const FRAMEWORKS = [
  { id: 'dispcontrols', label: 'DISP' },
  { id: 'e8controls', label: 'Essential 8' },
  { id: 'iso27701', label: 'ISO 27701' },
  { id: 'iso270012022annexacontrols', label: 'ISO 27001:2022' },
  { id: 'iso420012023controls', label: 'ISO 42001' },
  { id: 'qgov-is18', label: 'QGOV IS18' },
  { id: 'nist800-53-rev5', label: 'NIST 800-53 Rev 5' },
  { id: 'pacontrols', label: 'Privacy Act' },
  { id: 'soc2controls', label: 'SOC 2' },
  { id: 'ism', label: 'ISM' },
  { id: 'smb1001controls', label: 'SMB1001' },
] as const;

export type FrameworkId = typeof FRAMEWORKS[number]['id'];

export interface FrameworkOption {
  id: FrameworkId;
  label: string;
  checked: boolean;
}

// Audit types matching the original dialog
export const AUDIT_TYPES = [
  { value: '.', label: 'Select Audit Type', disabled: true },
  { value: 'Internal Audit', label: 'Internal Audit' },
  { value: 'External Audit', label: 'External Audit' },
] as const;

export type AuditType = typeof AUDIT_TYPES[number]['value'];

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface AuditInfo {
  typeOfAudit: AuditType;
  startDate: string;
  endDate: string;
}
